module.exports = __webpack_public_path__ + "img/trainers.483acb4e.png";